import type { UserRoleType } from '@omnipresentgroup/types';

import type { EmployeeType, ExpensePermissions, ResourceType } from '../types';
import { expensePermissionsMatrix } from './expense';

export const PERMISSION_MATRICES: Record<
  ResourceType,
  Record<EmployeeType, Record<UserRoleType, ExpensePermissions>>
> = {
  expense: expensePermissionsMatrix,
};
